module.exports = __webpack_public_path__ + "img/Group (15).947b58b8.svg";